import dayjs from 'dayjs';
import _ from 'lodash';

import { AiProcessExecutionStatus } from 'constants/aiProcessRuns';

import { SavedFilterChipId } from '../AiActivity.constants';

const ALL_FAILED_STATUSES = new Set([AiProcessExecutionStatus.FAILED]);

export const formatRunCount = count => (count === 1 ? '1 run' : `${count} runs`);

export const dateValueToIso = value => (value ? dayjs(value).toISOString() : null);

const isToday = isoDate => {
  if (_.isNil(isoDate)) {
    return false;
  }

  const ts = dayjs(isoDate);

  return ts.isValid() && ts.isSame(dayjs(), 'day');
};

const matchesText = (text, run, processName) => {
  if (_.isNil(text) || text === '') {
    return true;
  }

  const lowered = text.toLowerCase();

  return [processName, run?.errorMessage, run?.triggeredByUserName, run?.triggerSource]
    .filter(value => !_.isNil(value) && value !== '')
    .some(value => String(value).toLowerCase().includes(lowered));
};

export const applyClientSideFilters = ({
  runs,
  savedChips,
  searchText,
  processesById,
  currentUserId,
  needsReviewExecutionIds,
}) => {
  if (_.isEmpty(runs)) {
    return [];
  }

  const wantsToday = savedChips.includes(SavedFilterChipId.TODAY);
  const wantsProblemsOnly = savedChips.includes(SavedFilterChipId.PROBLEMS_ONLY);
  const wantsStartedByMe = savedChips.includes(SavedFilterChipId.STARTED_BY_ME);
  const wantsManualOnly = savedChips.includes(SavedFilterChipId.MANUAL_ONLY);
  const wantsNeedsReview = savedChips.includes(SavedFilterChipId.NEEDS_REVIEW);

  return runs.filter(run => {
    if (wantsToday && !isToday(run.startedAt)) {
      return false;
    }

    if (wantsProblemsOnly && !ALL_FAILED_STATUSES.has(run.status)) {
      return false;
    }

    if (wantsNeedsReview && !needsReviewExecutionIds?.has(run.id)) {
      return false;
    }

    if (wantsStartedByMe && run.triggeredByUserId !== currentUserId) {
      return false;
    }

    if (
      wantsManualOnly &&
      (_.isNil(run.triggerSource) || run.triggerSource.toLowerCase() !== 'manual')
    ) {
      return false;
    }

    const processName = processesById[run.aiProcessId]?.name ?? '';

    return matchesText(searchText, run, processName);
  });
};
